// components/UnitingSection.jsx
import SectionReveal from './SectionReveal';

export default function UnitingSection({ t }) {
  const items = t?.unitingItems || [];

  if (!items.length) return null;

  return (
    <section id="uniting" className="relative bg-white px-3 py-6 md:px-10">
      
      <div className="mx-auto max-w-7xl space-y-12">
        
        {/* Блок 1: Заголовок */}
        <SectionReveal>
          <div className="border-l-4 border-[#0FA4E8] bg-gray-50 p-6 md:p-10">
            <h2 className="text-2xl md:text-4xl font-black text-[#0B3B6F] uppercase">
              {t?.unitingTitle || 'Մենք միավորում ենք'}
            </h2>
          </div>
        </SectionReveal>

        {/* Блок 2: 4 карточки */}
        <SectionReveal delay={150}>
          <div className="border-l-4 border-[#0B3B6F] bg-gray-50 p-6 md:p-10">
            <div className="grid gap-6 sm:grid-cols-2">
              {items.map((item, idx) => (
                <div key={idx} className="flex items-start gap-4 p-5 bg-white border border-gray-100 hover:border-[#0FA4E8]/30 transition-all group">
                  
                  {/* Иконка */}
                  <span 
                    className="flex-shrink-0 text-[#0FA4E8] group-hover:text-[#0B3B6F] transition-colors"
                    dangerouslySetInnerHTML={{ __html: item.icon }}
                  />
                  
                  {/* Текст */}
                  <div>
                    <h3 className="text-base font-bold text-[#0B3B6F] group-hover:text-[#0FA4E8] transition-colors mb-1">
                      {item.title}
                    </h3>
                    <p className="text-sm text-slate-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </SectionReveal>

      </div>
    </section>
  );
}